import React from "react";
import Minefield from "./components/Minefield";

const Game = () => {
  return (
    <div className="Game">
      <Minefield></Minefield>
    </div>
  );
};

export default Game;
